import { useMount } from 'ahooks';
import React from 'react';
import EventEmitter from '../utils/util/eventEmitter';

interface IMouseCoordinates {
  x: number;
  y: number;
}

let lastMouseCoords = { x: 0, y: 0 };

const coordsEmitter = new (class extends EventEmitter<{
  coords: IMouseCoordinates;
}> {})();

document.addEventListener('mousemove', (ev) => {
  coordsEmitter.emit('coords', { x: ev.clientX, y: ev.clientY });
  lastMouseCoords = { x: ev.clientX, y: ev.clientY };
});

export default function useMousePosition() {
  const [mouseCoords, setMouseCoords] =
    React.useState<IMouseCoordinates>(lastMouseCoords);

  useMount(() => {
    coordsEmitter.on('coords', setMouseCoords);
    return () => coordsEmitter.off('coords', setMouseCoords);
  });

  return mouseCoords;
}
